import { render, staticRenderFns } from "./DeviceControlHistory.vue?vue&type=template&id=f24d50aa"
import script from "./DeviceControlHistory.vue?vue&type=script&lang=js"
export * from "./DeviceControlHistory.vue?vue&type=script&lang=js"
import style0 from "./DeviceControlHistory.vue?vue&type=style&index=0&id=f24d50aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports